import script from "./SubjectSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./SubjectSelection.vue?vue&type=script&setup=true&lang=js"

import "./SubjectSelection.vue?vue&type=style&index=0&id=5f6debb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f6debb2"]])

export default __exports__